import * as React from 'react';

const checkIsRTL = () =>
  document.documentElement.dir.toLocaleLowerCase() === 'rtl';

export default (): boolean => {
  const [isRTL, setIsRTL] = React.useState(checkIsRTL);

  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsRTL(checkIsRTL);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['dir'],
      attributeOldValue: true,
    });

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return isRTL;
};
